import hashString from '@/utils/hash';

export function getInitialsColor(firstName: string, lastName: string): string {
    // 500 variants of all tailwind colors https://tailwindcss.com/docs/customizing-colors
    const colors = [
        'var(--color-red-500)',
        'var(--color-orange-500)',
        'var(--color-amber-500)',
        'var(--color-yellow-500)',
        'var(--color-lime-500)',
        'var(--color-green-500)',
        'var(--color-emerald-500)',
        'var(--color-teal-500)',
        'var(--color-cyan-500)',
        'var(--color-sky-500)',
        'var(--color-blue-500)',
        'var(--color-indigo-500)',
        'var(--color-violet-500)',
        'var(--color-purple-500)',
        'var(--color-fuchsia-500)',
        'var(--color-pink-500)',
        'var(--color-rose-500)',
        'var(--color-slate-500)',
        'var(--color-gray-500)',
        'var(--color-zinc-500)',
        'var(--color-neutral-500)',
        'var(--color-stone-500)',
        'var(--color-taupe-500)',
        'var(--color-mauve-500)',
        'var(--color-mist-500)',
        'var(--color-olive-500)',
    ];

    return colors[hashString(firstName + lastName) % colors.length];
}
